<template>
  <div>
    <RouteSearch
      v-show="currentSearchState === 'search'"
      current="RouteSearch"
    />
    <DropSpotSelect
      v-show="currentSearchState === 'select'"
      current="RouteSearch"
    />
    <RouteResult
      v-if="currentSearchState === 'result'"
      current="RouteSearch" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import RouteSearch from "@/components/Pages/RouteSearch";
import DropSpotSelect from "@/components/Pages/DropSpotSelect";
import RouteResult from "@/components/Pages/RouteResult";

export default {
  name: "route-search-root",
  components: {
    RouteSearch,
    DropSpotSelect,
    RouteResult,
  },
  computed: {
    ...mapState(["currentPageName", "searchState"]),
    currentSearchState() {
      return this.searchState.dropspot;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/RouteSearchRoot.vue